import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import { Store } from 'redux';
import { createReceiveMessageAction } from 'streamsState/store/streamedData/actions.ts';
import { Logger } from '@instinet-analytics/core-lib';
import { OrderVolumeProfileElement } from '../../api/OrderVolumeProfileElement.ts';

export function getOrderVolumeProfileMessageHandler(
    store: Store,
    logger: Logger
): StreamDataHandlers<OrderVolumeProfileElement> {
    return {
        onMessage: (streamKey: string, message: OrderVolumeProfileElement) => {
            store.dispatch(
                createReceiveMessageAction(
                    'startOrderVolumeCurveStream',
                    streamKey,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    message as any
                )
            );
        },
        onError: (streamKey: string, error: StreamError) => {
            logger.critical('Error in startOrderVolumeCurveStream stream', {
                streamKey,
                error,
            });
        },
    };
}
